(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculatorLooseProduct"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
  $('[name^="bel_"]').each(function () {
    $(this).on('blur', function () {
      if ($(this).val() == '' || $(this).val() == null) {
        $(this).removeClass('form-field-filled');
      } else {
        $(this).addClass('form-field-filled');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculatorPaving"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
  $('[name^="bel_"]').each(function () {
    $(this).on('blur', function () {
      if ($(this).val() == '' || $(this).val() == null) {
        $(this).removeClass('form-field-filled');
      } else {
        $(this).addClass('form-field-filled');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
